/* eslint-disable react/no-array-index-key */
import { FC } from 'react';

import Image, { StaticImageData } from 'next/image';

import { colors } from '~/constants/colors';

import {
  Paragraph,
  ParagraphsContainer,
  ResponsiveImageWrapper,
} from "./styles";
import { TypographP, TypographSpan } from "../typograph";
import { PageTitle } from "../page-title";
import { PageContainer } from "../page-container";
import { OurPillars } from "../our-pillars";
import { BackToPageTop } from "../back-to-page-top";
import { MatchWithYourCompany } from "../match-with-your-company";

interface IParagraph {
  readonly main: string;
  readonly content: string;
  readonly greenContent?: boolean;
}

interface IPillarGenericPageProps {
  readonly title: string;
  readonly description: string;
  readonly subdescription: string;
  readonly image: StaticImageData;
  readonly paragraphs: IParagraph[];
}
export const PillarGenericPage: FC<IPillarGenericPageProps> = ({
  title,
  description,
  subdescription,
  image,
  paragraphs,
}) => {
  return (
    <PageContainer>
      <PageTitle title={title} description={description} />

      <TypographP color={colors.text_white} size={16} lineHeight={20.24} bold>
        {subdescription}
      </TypographP>

      <ResponsiveImageWrapper>
        <Image src={image} alt={title} />
      </ResponsiveImageWrapper>

      <ParagraphsContainer>
        {paragraphs.map((paragraph, index) => (
          <Paragraph key={String(index)}>
            <TypographSpan
              color={colors.text_white}
              size={14}
              lineHeight={18.24}
              bold
              italic
            >
              {paragraph.main}:{" "}
              <TypographSpan
                color={
                  paragraph.greenContent ? colors.green : colors.text_white
                }
                size={14}
                lineHeight={18.24}
                weak
                opacity={0.8}
              >
                {paragraph.content}
              </TypographSpan>
            </TypographSpan>
          </Paragraph>
        ))}
      </ParagraphsContainer>

      <BackToPageTop />

      <OurPillars />

      <MatchWithYourCompany />
    </PageContainer>
  );
};
